angular.module('app').factory('licenseService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/license/");

        return {
            get: function () {
                return restAngular.one("get").get()
            }
        }
    }
]);